import { render, staticRenderFns } from "./SettingsSelect.vue?vue&type=template&id=37c0a5f6&scoped=true"
import script from "./SettingsSelect.vue?vue&type=script&lang=ts"
export * from "./SettingsSelect.vue?vue&type=script&lang=ts"
import style0 from "./SettingsSelect.vue?vue&type=style&index=0&id=37c0a5f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c0a5f6",
  null
  
)

export default component.exports